import styled from "@emotion/styled";
export const StyledBadgesGridMobileComponent = styled.div`
  .badge-wrapper {
    padding: 8px;
  }

  .slick-list {
    padding: 0 20% 0;

    .slick-track {
      .slick-slide {
        .picture-component {
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
      }
    }
  }
`;
